import React from 'react';
import styled from 'styled-components';
import Hero from './components/Hero';
import PainSection from './components/PainSection';
import BenefitsSection from './components/BenefitsSection';
import ProgramSection from './components/ProgramSection';
import ForWhoSection from './components/ForWhoSection';
import TestimonialsSection from './components/TestimonialsSection';
import AboutEduardoSection from './components/AboutEduardoSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import CookieBanner from './components/CookieBanner';

const MainContainer = styled.main`
  min-height: 100vh;
  background-color: #EAF4FB;
`;

function App() {
  return (
    <MainContainer>
      <Hero />
      <PainSection />
      <BenefitsSection />
      <ProgramSection />
      <ForWhoSection />
      <TestimonialsSection />
      <AboutEduardoSection />
      <CTASection />
      <FAQSection />
      <Footer />
      <Chatbot />
      <CookieBanner />
    </MainContainer>
  );
}

export default App; 